import { Request } from '@/classes/Request.ts'

export const saveLowBalanceNoticeLevel = async (
  familyAccountId: number,
  payload: Object
): Promise<any> => {
  return new Promise((resolve, reject) => {
    const req = new Request()
    req
      .post(`/ajax/family/${familyAccountId}/save_low_balance_level_data`, payload)
      .then(result => {
        resolve(result.data)
      })
      .catch(err => {
        reject(err)
      })
  })
}
